import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import compose from 'recompose/compose';
import { createSelector } from 'reselect';
import classnames from 'classnames';
import { createTask } from 'bpm/createTask/actions';
// import DateInput from '../../../../fieldFactory/input/components/DateInput';
import { reduxForm, Field } from 'redux-form';
import { processActivityEventCreator } from '../../../actions/processActivityEvent';
import ITask from '../../../types/task';
import { RootState } from '../../../../reducers/rootReducer';
import { mapToApiType } from '../../../dataAdapters/network/rest/tasks/entities/task';
import { Button, FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@material-ui/core';
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core/styles';
// import LongTextInput from '../../../../fieldFactory/input/components/LongTextInput';
import { Dispatch } from 'redux';
import { fromNullable } from 'fp-ts/lib/Option';
import { Activity } from 'bpm/reducer/processActivities';
import uniqueId from 'lodash/uniqueId';
import { initial } from '@devexperts/remote-data-ts';
import { required } from 'fieldFactory/util/validate';
import withState from 'recompose/withState';
/*
    This is used to typecheck the fields in our form against our Task interface at compile time.
    for example, (use f.assignee, instead of "assignee")
*/
const f: { [key: string]: keyof ITask } = {
    dueDate: 'dueDate',
    priority: 'priority',
    name: 'name',
    description: 'description',
    taskDefinitionKey: 'taskDefinitionKey',
};

const styles = (theme: Theme) =>
    createStyles({
        error: {
            color: theme.palette.error.main,
        },
        formControl: {
            marginRight: theme.spacing(2),
            minWidth: 195,
        },
        menuItem: {
            zIndex: 4444,
        },
        inputStyle: {
            fontSize: 12,
            color: 'black',
        },
    });

const makeMapStateToProps = () => {
    const activitiesSelector = createSelector(
        (state: RootState) => state.bpm.processActivities.byId,
        (state: RootState, props: CreateTaskFormProps) =>
            state.bpm.processActivities.byProcess[props.processId] || initial,
        (byId, processData) => processData.map(activityIds => (activityIds || []).map(id => byId[id])),
    );

    const mapStateToProps = (state: RootState, props: CreateTaskFormProps) => ({
        activities: activitiesSelector(state, props),
    });
    return mapStateToProps;
};

const mapDispatchToProps = (
    dispatch: Dispatch,
    ownProps: CreateTaskFormProps & {
        isPending: boolean;
        setPending: (pending: boolean) => void;
    },
) => ({
    onSubmit: (values: {}) => {
        ownProps.setPending(true);
        dispatch(
            createTask(
                {
                    ...values,
                    ...(ownProps.processId ? { processInstanceId: ownProps.processId } : {}),
                },
                response => {
                    ownProps.setPending(false);
                    ownProps.handleClose();
                    if (response.processInstanceId) {
                        dispatch(push(`/processes/${response.processInstanceId}/tasks/${response.id}/start`));
                    } else {
                        dispatch(push(`/tasks/${response.id}`));
                    }
                },
                {
                    '*': () => {
                        ownProps.setPending(false);
                    },
                },
            ),
        );
    },
    getProcessActivities: (
        pid: string,
        onSuccess: (data: Activity[]) => void = () => null,
        onError: () => void = () => null,
    ) => {
        dispatch(processActivityEventCreator.getProcessActivities(pid, onSuccess, onError));
    },
});

interface CreateTaskFormProps {
    processId: string;
    handleClose: () => void;
}

interface CreateTaskFormComponentProps
    extends CreateTaskFormProps,
        WithStyles<typeof styles>,
        ReturnType<typeof mapDispatchToProps>,
        ReturnType<ReturnType<typeof makeMapStateToProps>> {
    // from reduxform
    isPending: boolean;
    setPending: (pending: boolean) => void;
    handleSubmit: (cb: (values: ITask) => void) => () => void;
}

interface CreateTaskFormComponentState {
    open: boolean;
    currentDescription: string;
}
class CreateTaskFormComponent extends React.Component<CreateTaskFormComponentProps, CreateTaskFormComponentState> {
    inputLabelId = uniqueId('CreatTaskForm-inputLabel');
    state: CreateTaskFormComponentState = {
        open: false,
        currentDescription: '',
    };
    componentDidMount() {
        this.props.getProcessActivities(this.props.processId);
    }
    setCurrentDescription = taskId => {
        const currentDescription = this.props.activities
            .toOption()
            .map(sps => sps.find(d => d.id === taskId))
            .chain(fromNullable)
            .map(d => d.description)
            .chain(fromNullable)
            .getOrElse('');
        this.setState({ currentDescription });
    };
    handleDropDownChange = taskId => {
        this.setCurrentDescription(taskId);
    };
    render() {
        const { activities, handleSubmit, onSubmit, classes, processId, handleClose } = this.props;
        if (activities.isInitial() || activities.isPending()) {
            return <CircularProgress />;
        }
        if (activities.isFailure()) {
            const error = activities.error;
            const msg = error instanceof Error ? error.message : error.body || error.status;
            return <div>Ad-hoc Tasks not available{msg ? `: ${msg}` : ''}</div>;
        }
        const activityData = activities.value;
        if (activityData.length === 0) {
            return <div>No Ad-hoc Tasks found for the current case.</div>;
        }
        return (
            <div>
                <form autoComplete="off">
                    <h3 style={{ marginBottom: '1em' }}>New Task</h3>
                    {processId ? (
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            <Field
                                name={f.taskDefinitionKey}
                                validate={required}
                                component={({ meta: { touched, error }, input }) => (
                                    <FormControl className={classes.formControl}>
                                        <InputLabel shrink={true} id={this.inputLabelId}>
                                            Activity Type
                                        </InputLabel>
                                        <Select
                                            value={input.value}
                                            onChange={event => {
                                                input.onChange(event.target.value);
                                                this.handleDropDownChange(event.target.value);
                                            }}
                                            SelectDisplayProps={{ 'aria-describedby': this.inputLabelId }}
                                            inputProps={{
                                                name: 'activity-type',
                                                id: 'activity-type',
                                            }}
                                            MenuProps={{
                                                style: { zIndex: 324234 },
                                                MenuListProps: { title: 'Activity Type' },
                                            }}
                                        >
                                            {activityData &&
                                                Object.values(activityData).map(activity => (
                                                    <MenuItem
                                                        className={classnames('dropdownMenuItem', classes.menuItem)}
                                                        key={activity.id}
                                                        value={activity.id}
                                                    >
                                                        {activity.name}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                        <span className={classes.error}>{touched && error}</span>
                                    </FormControl>
                                )}
                            />
                            {this.state.currentDescription}
                        </div>
                    ) : null}
                    <br />
                    {/*
                    <div>
                        <Field
                            name={f.dueDate}
                            component={DateInput}
                            label="Due Date"
                            aria-label="due date"
                        />
                    </div><br/>
                    <div>
                        <Field
                            name={f.description}
                            component={LongTextInput}
                            props={{ rows: 3, customStyles: {width: '50%'} }}
                            label="Description"
                            aria-label="description"
                        />
                    </div>
                    */}
                    <div style={{ textAlign: 'center', marginTop: '1em' }}>
                        <Button
                            color="primary"
                            disabled={this.props.isPending}
                            onClick={() => handleClose()}
                            style={{ marginRight: '5%' }}
                        >
                            Cancel
                        </Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button
                            disabled={this.props.isPending}
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit((values: ITask) => onSubmit(mapToApiType(values)))}
                        >
                            Create {this.props.isPending && <CircularProgress style={{ height: 20, width: 20 }} />}
                        </Button>
                    </div>
                </form>
            </div>
        );
    }
}

const CreateTaskForm: React.SFC<CreateTaskFormProps> = compose(
    withState('isPending', 'setPending', false),
    connect(
        makeMapStateToProps,
        mapDispatchToProps,
    ),
    reduxForm({
        enableReinitialize: true,
        form: 'create-task-form',
    }),
    withStyles(styles),
)(CreateTaskFormComponent);

export default CreateTaskForm;
